import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { getAllEmployee } from "../../../actions/employeeAction";
import { createEmployeeLoanPayment } from "../../../actions/loanPaymentManagementAction";
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  DatePicker,
  Drawer,
  TreeSelect,
  Button,
  Col,
  Row,
  Select,
  message,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

const CreateNewEmployeeLoanPayment = ({
  createEmployeeLoanPayment,
  updatelist,
  setUpdatelist,
  details,
}) => {
  const initial = { remarks: "" };
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const showDrawer = () => {
    console.log(details.total_due_payment)
    setVisible(true);
  };

  const onClose = () => {
    form.resetFields();
    setVisible(false);
  };

  const onFinish = (values) => {
    values.employee = details.employee.id;
    values.loan = details.id;
    values.type="partial payment";
    createEmployeeLoanPayment(values).then(res => {
      form.resetFields();
      setUpdatelist(!updatelist);
      setVisible(false);
    })
  };

  return (
    <>
      <>
        <Button
          type="link"
          onClick={showDrawer}
          
        >
          New payment
        </Button>
        <Drawer
          title="New Payment"
          width={400}
          onClose={onClose}
          visible={visible}
          bodyStyle={{ paddingBottom: 80 }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={initial}
          > 
            <Row gutter={16}>
              
              <Col span={24}>
                <Form.Item
                  name="paidAmount"
                  label="New Payment Amount"
                  rules={[
                    {
                      required: true,
                      message: "Please enter New Payment Amount",
                    },
                  ]}
                >
                  <InputNumber
                    placeholder="Please enter New Payment Amount"
                    min={0}
                    max={details?.total_due_payment}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item>
              <Button onClick={onClose} style={{ marginRight: 8 }}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Drawer>
      </>
    </>
  );
};



export default connect(null, { getAllEmployee, createEmployeeLoanPayment })(
  CreateNewEmployeeLoanPayment
);
